export enum NavigationContextType {
  admin = 'admin',
  customer = 'customer',
  service = 'service',
}

export interface MainNavigationProps {
  className?: string;
  context?: NavigationContextType;
  searchComponentEnabled?: boolean;
  testId?: string;
}
